export default __webpack_public_path__ + "0480054fbb271c39de5e07c319c7dbe1.svg";